export default {
  selectedDesign: {
    id: 'design_pickers_selected_design_alt',
    defaultMessage: 'Selected design {designType}',
  },
}
